export class Reports {
    title: string;
}

export const REPORTS = [
    {
        type: 'Social Security',
        clientID: 1134,
        clientFirstName: 'Klaus',
        clientLastName: 'Shapleigh',
        createdDate: '1/1/2016',
    },
    {
        type: 'Healthcare',
        clientID: 1134,
        clientFirstName: 'Klaus',
        clientLastName: 'Shapleigh',
        createdDate: '7/8/2017',
    },
    {
        type: 'Healthcare',
        clientID: 994,
        clientFirstName: 'King',
        clientLastName: 'Kong',
        createdDate: '5/13/2017',
    },
    {
        type: 'Social Security',
        clientID: 1130,
        clientFirstName: 'Joe',
        clientLastName: 'Smith',
        createdDate: '12/8/2017',
    },
    {
        type: 'Healthcare',
        clientID: 456,
        clientFirstName: 'Bob',
        clientLastName: 'Reynor',
        createdDate: '4/2/2017',
    }
]
